import Modal from "./common/modal.es6";
import { setVariables } from "./common/setvariables.es6";
import { debug } from "./common/debug.es6";
import UI from "./ui.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        //common functions
        setVariables();
        const debugMode = debug();
        //this.modal = new Modal();
        this.ui = new UI();
    }
}
